module.exports = require('./lib/reset')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/reset.js
// module id = 305
// module chunks = 213534597649335